import PolicyLayout from './PolicyLayout';
import { SITE_DOMAIN, SITE_NAME } from '../constants/site';

export default function TermsOfService() {
  return (
    <PolicyLayout title="Terms of Service">
      <p>
        Effective date: April 9, 2026. By accessing or using <strong>{SITE_DOMAIN}</strong>, operated by {SITE_NAME}, you agree to these Terms of
        Service. If you do not agree with any part of these terms, please discontinue use of this website.
      </p>
      <h2>Acceptance of Terms</h2>
      <p>
        Your continued access to the website constitutes acceptance of these terms, our Privacy Policy, and any
        additional notices posted across relevant pages.
      </p>
      <h2>Website Purpose</h2>
      <p>
        Website content is provided for general educational and how-to guidance related to Family Tree Maker software,
        migration, backup, and troubleshooting.
      </p>
      <h2>Brand Independence</h2>
      <p>
        This website provides informational support resources. It is not affiliated with, endorsed by, or sponsored by
        any third-party genealogy software vendor unless we say so in writing.
      </p>
      <h2>User Responsibility</h2>
      <p>
        You are responsible for verifying system compatibility, backup availability, account credentials, and data
        integrity before applying technical steps or recommendations found on this website.
      </p>
      <h2>Permitted Use</h2>
      <p>
        You may use this website for lawful personal or business information purposes. You may not misuse the
        website, attempt access without permission, interfere with service operation, or use automated scraping tools
        without permission.
      </p>
      <h2>Intellectual Property</h2>
      <p>
        All website text, branding, structure, graphics, and design elements are protected by applicable
        intellectual property laws. Reproduction, redistribution, or modification without written permission is
        prohibited.
      </p>
      <h2>Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, we are not liable for direct, indirect, incidental, or consequential
        losses resulting from website use, service interruption, software conflicts, data loss, or user-applied
        technical actions.
      </p>
      <h2>Disclaimer of Warranties</h2>
      <p>
        The website is provided on an &quot;as is&quot; and &quot;as available&quot; basis without warranties of any
        kind, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.
      </p>
      <h2>External Links</h2>
      <p>
        External links are provided for convenience. We do not control third-party websites and are not responsible
        for their content, security practices, or policy changes.
      </p>
      <h2>Governing Law</h2>
      <p>
        These terms are governed by applicable laws in the jurisdiction where website operations are managed,
        without regard to conflict-of-law rules.
      </p>
      <h2>Changes to Terms</h2>
      <p>
        We may update these terms at any time. Continued use after updates are published constitutes acceptance of
        the revised Terms of Service.
      </p>
    </PolicyLayout>
  );
}
